import { changeFormFieldValue } from 'actions/formAction';

import { DELIVERY_METHOD } from 'constants/fieldsName';
import { REQUEST_FORM_NAME } from 'constants/formName';

export const UPDATE_REQUEST_PAYMENT_FORM = 'UPDATE_REQUEST_PAYMENT_FORM';

export const SET_REQUEST_DELIVERY_METHOD = 'SET_REQUEST_DELIVERY_METHOD';

export const updateRequestPaymentForm = (requestForm) => {
    return (dispatch) => {
        return Promise.resolve(
            dispatch({
                type: UPDATE_REQUEST_PAYMENT_FORM,
                requestForm: requestForm,
            }),
        );
    };
};

export const setRequestDeliveryMethod = (methodName) => {
    return (dispatch) => {
        dispatch(changeFormFieldValue(REQUEST_FORM_NAME, methodName, DELIVERY_METHOD));
        dispatch({ type: SET_REQUEST_DELIVERY_METHOD, method: methodName });
        return Promise.resolve();
    };
};
